/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Application": [
      "AudiFinancingApplication",
      "BmwApplication",
      "ConfiguratorApplication",
      "EventApplication",
      "FinderApplication",
      "MobilityApplication",
      "SDMApplication",
      "StandardApplication"
    ],
    "ApplicationAgreement": [
      "CheckboxApplicationAgreement",
      "MarketingApplicationAgreement",
      "TextApplicationAgreement"
    ],
    "ApplicationConfiguratorBlock": [
      "ApplicationConfiguratorColorSetting",
      "ApplicationConfiguratorOptionSetting",
      "ApplicationConfiguratorPackageSetting",
      "ApplicationConfiguratorTrimSetting"
    ],
    "ApplicationDeposit": [
      "ApplicationAdyenDeposit",
      "ApplicationFiservDeposit",
      "ApplicationPayGateDeposit",
      "ApplicationPorscheDeposit",
      "ApplicationTtbDeposit"
    ],
    "ApplicationFinancing": [
      "DefaultApplicationFinancing",
      "NewZealandApplicationFinancing",
      "SingaporeApplicationFinancing"
    ],
    "ApplicationInsurancing": [
      "DefaultApplicationInsurancing",
      "NewZealandApplicationInsurancing",
      "SingaporeApplicationInsurancing"
    ],
    "ApplicationMarketType": [
      "DefaultApplicationMarket",
      "NewZealandApplicationMarket",
      "SingaporeApplicationMarket"
    ],
    "ApplicationOptionSettings": [
      "ApplicationComboSettings",
      "DropdownOptionSettings",
      "MultiSelectOptionSettings",
      "SingleSelectOptionSettings"
    ],
    "ApplicationQuotation": [
      "EnbdApplicationQuotation"
    ],
    "ApplicationSigning": [
      "ApplicationNamirialSigning",
      "ApplicationOTPSigning"
    ],
    "ApplicationStageDetails": [
      "AppointmentStage",
      "FinancingStage",
      "InsuranceStage",
      "LeadStage",
      "MobilityStage",
      "ReservationStage"
    ],
    "AppointmentChangedVehicle": [
      "AppointmentChangedVehicleLocal",
      "AppointmentChangedVehicleText"
    ],
    "AudiFinancingDetails": [
      "AudiFinancingDBSNewCarFinance",
      "AudiFinancingDBSUsedCarFinance",
      "AudiFinancingHLFNewCarFinance",
      "AudiFinancingHLFUsedCarFinance",
      "AudiFinancingUOBNewCarFinance",
      "AudiFinancingUOBUsedCarFinance"
    ],
    "AudiFinancingVehicle": [
      "AudiFinancingNewVehicle",
      "AudiFinancingUsedVehicle"
    ],
    "AuthenticationResponse": [
      "AuthenticationRequiresNewPassword",
      "AuthenticationRequiresSmsOTP",
      "AuthenticationRequiresTOTP",
      "AuthenticationSuccessful"
    ],
    "Author": [
      "CorporateCustomer",
      "ExternalBank",
      "Guarantor",
      "LocalCustomer",
      "Salesforce",
      "SystemBank",
      "User"
    ],
    "BalloonSettings": [
      "BalloonRangeSettings",
      "BalloonTableSettings"
    ],
    "Bank": [
      "ExternalBank",
      "SystemBank"
    ],
    "BankIntegration": [
      "BmwFsBankIntegration",
      "DbsBankIntegration",
      "EmailBankIntegration",
      "EnbdBankIntegration",
      "HlfBankIntegration",
      "HlfBankV2Integration",
      "MaybankIntegration",
      "UobBankIntegration"
    ],
    "Block": [
      "ColorBlock",
      "OptionsBlock",
      "PackageBlock",
      "TrimBlock"
    ],
    "BmwFinance": [
      "BmwDBSNewCarFinance",
      "BmwDBSUsedCarFinance"
    ],
    "BmwVehicle": [
      "BmwNewVehicle",
      "BmwUsedVehicle"
    ],
    "CalculatorResult": [
      "CalculatorDeferredPrincipalResult",
      "CalculatorHirePurchaseResult",
      "CalculatorHirePurchaseWithBalloonGFVResult",
      "CalculatorHirePurchaseWithBalloonResult",
      "CalculatorLeasePurchaseResult",
      "CalculatorLeaseResult",
      "CalculatorUcclLeasingResult"
    ],
    "Condition": [
      "ApplicationModuleCondition",
      "BankCondition",
      "ContextualCondition",
      "DealerCondition",
      "GiftVoucherCondition",
      "InsurerCondition",
      "LocationCondition",
      "LogicCondition"
    ],
    "Configurator": [
      "ModelConfigurator",
      "VariantConfigurator"
    ],
    "ConsentsAndDeclarations": [
      "CheckboxConsentsAndDeclarations",
      "MarketingConsentsAndDeclarations",
      "TextConsentsAndDeclarations"
    ],
    "Customer": [
      "CorporateCustomer",
      "Guarantor",
      "LocalCustomer"
    ],
    "DealershipSetting": [
      "DealershipMyInfoSetting",
      "DealershipPaymentSetting",
      "DealershipPublicSalesPerson"
    ],
    "DepositSettings": [
      "DepositRangeSettings",
      "DepositTableSettings"
    ],
    "DiscountCode": [
      "GiftVoucher",
      "PromoCode"
    ],
    "DownPaymentSettings": [
      "DownPaymentRangeSettings",
      "DownPaymentTableSettings"
    ],
    "EmailSettings": [
      "SMTPEmailSettings",
      "SystemEmailSettings"
    ],
    "Endpoint": [
      "ApplicationListEndpoint",
      "ConfiguratorApplicationEntrypoint",
      "CustomerListEndpoint",
      "DummyPrivatePageEndpoint",
      "DummyWelcomePageEndpoint",
      "EventApplicationEntrypoint",
      "FinderApplicationEntrypoint",
      "FinderApplicationPublicAccessEntrypoint",
      "MobilityApplicationEntrypoint",
      "StandardApplicationEntrypoint",
      "StandardApplicationPublicAccessEntrypoint",
      "WebPageEndpoint"
    ],
    "ExternalLink": [
      "AdyenRedirectionLink",
      "ApplyNewRedirectionLink",
      "CTSFinderRedirectionLink",
      "ConfiguratorApplicationLink",
      "CreateNewUserLink",
      "EventApplicationLink",
      "FinderApplicationLink",
      "FiservPaymentRedirectionLink",
      "GiftVoucherAdyenRedirectionLink",
      "GiftVoucherFiservPaymentRedirectionLink",
      "GiftVoucherPayGatePaymentRedirectionLink",
      "GiftVoucherPorschePaymentRedirectionLink",
      "GiftVoucherTtbPaymentRedirectionLink",
      "MobilityApplicationAmendmentLink",
      "MobilityApplicationCancellationLink",
      "MyInfoCallbackLink",
      "NamirialSigningLink",
      "PayGatePaymentRedirectionLink",
      "PorschePaymentRedirectionLink",
      "ProceedWithCustomerLink",
      "ResetPasswordLink",
      "StandardApplicationLink",
      "TestDriveProcessRedirectionLink",
      "TtbPaymentRedirectionLink",
      "VerifyEmailUpdateLink"
    ],
    "FinanceProduct": [
      "LocalDeferredPrincipal",
      "LocalHirePurchase",
      "LocalHirePurchaseWithBalloon",
      "LocalHirePurchaseWithBalloonGFV",
      "LocalLease",
      "LocalLeasePurchase",
      "LocalUcclLeasing"
    ],
    "ICurrencyType": [
      "Currency",
      "DownPayment",
      "Price",
      "Rate"
    ],
    "ILocalizedValue": [
      "LocalizedColorGroup",
      "LocalizedInteriorColorGroup",
      "LocalizedModelCategory",
      "LocalizedModelGeneration",
      "LocalizedValue"
    ],
    "ImportInventoryResponse": [
      "ImportInventoryFail",
      "ImportInventorySuccess"
    ],
    "InsurerIntegration": [
      "EazyInsurerIntegration",
      "EmailInsurerIntegration"
    ],
    "InterestRateSettings": [
      "InterestRateFixedSettings",
      "InterestRateRangeSettings",
      "InterestRateTableSettings"
    ],
    "Inventory": [
      "ConfiguratorInventory",
      "MobilityInventory"
    ],
    "Layout": [
      "BasicLayout",
      "BasicProLayout"
    ],
    "LiveChatSetting": [
      "UserlikeChatbotSetting",
      "WhatsappLiveChatSetting"
    ],
    "LocalCustomerField": [
      "LocalCustomerDateField",
      "LocalCustomerDrivingLicenseField",
      "LocalCustomerNumberField",
      "LocalCustomerPhoneField",
      "LocalCustomerReferenceDetailSetField",
      "LocalCustomerSalaryTransferredBankSetField",
      "LocalCustomerStringDescriptionField",
      "LocalCustomerStringField",
      "LocalCustomerUAEIdentitySetField",
      "LocalCustomerUploadsField"
    ],
    "MenuItem": [
      "MenuCustomPathItem",
      "MenuEndpointItem",
      "MenuLogoutActionItem"
    ],
    "Mobility": [
      "MobilityAdditionalInfo",
      "MobilityAddon"
    ],
    "MobilityBookingLocation": [
      "MobilityBookingLocationHome",
      "MobilityBookingLocationPickup"
    ],
    "MobilitySnapshot": [
      "MobilityAdditionalInfoSnapshot",
      "MobilityAddonSnapshot"
    ],
    "Module": [
      "AdyenPaymentModule",
      "AppointmentModule",
      "AudiCalculationModule",
      "AudiFinancingModule",
      "AudiSalesForceModule",
      "AutoplayModule",
      "BankModule",
      "BasicSigningModule",
      "BmwModule",
      "CapModule",
      "ConfiguratorModule",
      "ConsentsAndDeclarationsModule",
      "CtsModule",
      "EventApplicationModule",
      "FinderApplicationPrivateModule",
      "FinderApplicationPublicModule",
      "FinderVehicleManagementModule",
      "FiservPaymentModule",
      "GiftVoucherModule",
      "InsuranceModule",
      "LabelsModule",
      "LocalCustomerManagementModule",
      "MaintenanceModule",
      "MobilityModule",
      "MyInfoModule",
      "NamirialSigningModule",
      "PayGatePaymentModule",
      "PorscheMasterDataModule",
      "PorschePaymentModule",
      "PromoCodeModule",
      "SdmModule",
      "SimpleVehicleManagementModule",
      "StandardApplicationModule",
      "TradeInModule",
      "TtbPaymentModule",
      "UserlikeChatbotModule",
      "WebsiteModule",
      "WhatsappLiveChatModule"
    ],
    "ModuleWithSalesForceSetting": [
      "AudiFinancingModule",
      "SdmModule"
    ],
    "OptionSettings": [
      "ComboOptionSettings",
      "DropdownOptionSettings",
      "MultiSelectOptionSettings",
      "SingleSelectOptionSettings"
    ],
    "PackageType": [
      "PackageTypeWithDescription",
      "PackageTypeWithPrice"
    ],
    "PaymentSetting": [
      "AdyenPaymentSetting",
      "FiservPaymentSetting",
      "PayGatePaymentSetting",
      "PorschePaymentSetting",
      "TtbPaymentSetting"
    ],
    "PromoType": [
      "DiscountPromoType",
      "GiftPromoType"
    ],
    "SDMFinancing": [
      "DBSNewCarFinance",
      "DBSUsedCarFinance",
      "HLFNewCarFinance",
      "HLFUsedCarFinance",
      "MaybankNewCarFinance",
      "MaybankUsedCarFinance",
      "UOBNewCarFinance",
      "UOBUsedCarFinance"
    ],
    "SDMVehicle": [
      "SDMNewVehicle",
      "SDMUsedVehicle"
    ],
    "SmsSettings": [
      "SystemSmsSettings"
    ],
    "StockInventory": [
      "ConfiguratorStockInventory",
      "MobilityStockInventory"
    ],
    "SystemMessage": [
      "MaintenanceUpdate",
      "MessageNotice",
      "UserSessionRevoked"
    ],
    "TermSettings": [
      "DeferredPrincipalTermSettings",
      "GenericPrincipalTermSettings"
    ],
    "TradeIn": [
      "AudiTradeIn"
    ],
    "UploadFileInterface": [
      "ApplicationDocument",
      "UploadedFile",
      "UploadedFileWithPreview"
    ],
    "Vehicle": [
      "FinderVehicle",
      "LocalMake",
      "LocalModel",
      "LocalVariant"
    ],
    "WebPageBlock": [
      "ColumnWebPageBlock",
      "CustomWebPageBlock",
      "ImageWebPageBlock",
      "TextCarouselWebPageBlock",
      "TextImageWebPageBlock"
    ]
  }
};
      export default result;
    